import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const convertHTMLToPDF = htmlToPDFData => {
  const { htmlElement, filename, imgFormat, jsPDFOptions } = htmlToPDFData || {};

  if (!htmlElement || !filename || !jsPDFOptions || !imgFormat) return null;

  html2canvas(htmlElement).then(canvas => {
    //* imageData as base64 encoded DataUrl or Image-HTMLElement or Canvas-HTMLElement
    const imageData = canvas.toDataURL('image/png');

    //* jsPDF doc: https://artskydj.github.io/jsPDF/docs/jsPDF.html
    //* Create a new jsPDF object.
    const pdfObject = new jsPDF(jsPDFOptions);

    const pdfWidth = pdfObject.internal.pageSize.getWidth();
    const pdfHeight = pdfObject.internal.pageSize.getHeight();
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;
    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    const imgXCoOrdinate = (pdfWidth - imgWidth * ratio) / 2;
    const imgYoOrdinate = 5;

    //* Adding image into pdf.
    pdfObject.addImage(
      imageData,
      imgFormat,
      imgXCoOrdinate,
      imgYoOrdinate,
      imgWidth * ratio,
      imgHeight * ratio,
    );

    //* Downloading pdf as <filename>.
    pdfObject.save(filename);
  });
};
